var map = {
	"./modules/admin/admin.module": [
		"./src/app/modules/admin/admin.module.ts",
		"default~modules-admin-admin-module~modules-insurance-motor-car-motor-car-insurance-module~modules-in~16f10ee6",
		"default~modules-admin-admin-module~public-public-module",
		"common",
		"modules-admin-admin-module"
	],
	"./modules/claim/claim.module": [
		"./src/app/modules/claim/claim.module.ts",
		"modules-claim-claim-module"
	],
	"./modules/insurance/health-accident/health-insurance.module": [
		"./src/app/modules/insurance/health-accident/health-insurance.module.ts",
		"default~modules-insurance-health-accident-health-insurance-module~modules-insurance-motor-car-motor-~08a225ce",
		"common",
		"modules-insurance-health-accident-health-insurance-module"
	],
	"./modules/insurance/motor-car/motor-car-insurance.module": [
		"./src/app/modules/insurance/motor-car/motor-car-insurance.module.ts",
		"default~modules-insurance-health-accident-health-insurance-module~modules-insurance-motor-car-motor-~08a225ce",
		"default~modules-admin-admin-module~modules-insurance-motor-car-motor-car-insurance-module~modules-in~16f10ee6",
		"default~modules-insurance-motor-car-motor-car-insurance-module~modules-insurance-motor-motor-insuran~9c030686",
		"common",
		"modules-insurance-motor-car-motor-car-insurance-module"
	],
	"./modules/insurance/motor/motor-insurance.module": [
		"./src/app/modules/insurance/motor/motor-insurance.module.ts",
		"default~modules-insurance-health-accident-health-insurance-module~modules-insurance-motor-car-motor-~08a225ce",
		"default~modules-admin-admin-module~modules-insurance-motor-car-motor-car-insurance-module~modules-in~16f10ee6",
		"default~modules-insurance-motor-car-motor-car-insurance-module~modules-insurance-motor-motor-insuran~9c030686",
		"common",
		"modules-insurance-motor-motor-insurance-module"
	],
	"./modules/insurance/travel/travel-insurance.module": [
		"./src/app/modules/insurance/travel/travel-insurance.module.ts",
		"default~modules-insurance-health-accident-health-insurance-module~modules-insurance-motor-car-motor-~08a225ce",
		"common",
		"modules-insurance-travel-travel-insurance-module"
	],
	"./modules/payment/payment.module": [
		"./src/app/modules/payment/payment.module.ts",
		"common",
		"modules-payment-payment-module"
	],
	"./modules/user/user.module": [
		"./src/app/modules/user/user.module.ts",
		"modules-user-user-module"
	],
	"./public/public.module": [
		"./src/app/public/public.module.ts",
		"default~modules-admin-admin-module~public-public-module",
		"common",
		"public-public-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;